import React from 'react';
import PropTypes from 'prop-types';
import useIdleModal from '../../hooks/idleModalHook';
import { getStatesList } from '../../flows/shared/services/states-service';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import styles from './style.css';
import { modalCloseHandler } from '../Modal/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';

const TimeOutModal = ({ warningTimeManualExpire = false }) => {
  const { warningTimeExpired, userSessionExpired, logout } = useIdleModal();

  const handleSessionReset = async () => {
    /* 
      call a service here instead of directly restarting JS timer... 
      calling a service accomplishes two things:
      1) any service call *should* keep the session active on the backend.
      2) IdleModal has a registerResponseHook to restart the JS timer
      on any API call (built using buildService from decorated-service)      
    */
    modalCloseHandler();
    await getStatesList();
  };

  const handleCloseBtnClick = () => {
    return userSessionExpired ? logout() : handleSessionReset();
  };

  const warningExpire = warningTimeExpired || warningTimeManualExpire;

  const modalDescription = userSessionExpired
    ? `You have been logged out due to inactivity.`
    : `You are about to be logged out due to inactivity. Would you
        like to extend your session?`;

  return (
    <>
      {warningExpire && (
        <MFBeaconModal open removeCloseButton role="dialog">
          <span className="modal-close-icon">
            <MFBeaconIconButton
              id="timeoutModalCloseIcon"
              data-name="timeoutModalCloseIcon"
              variant="tertiary"
              onClick={() => {
                modalCloseHandler();
                handleCloseBtnClick();
              }}
              label="close-button">
              <img slot="icon" src={closeBtn} alt="close icon" />
            </MFBeaconIconButton>
          </span>
          <div className="beacon-modal__description">{modalDescription}</div>
          {userSessionExpired ? (
            <div slot="action-zone" className="timeout-modal-btn-container">
              <MFBeaconButton
                noButtonMargin
                variant="primary"
                id="timeoutModalForcedLogout"
                data-name="timeoutModalForcedLogout"
                onClick={() => {
                  modalCloseHandler();
                  logout();
                }}
                label="Continue"
              />
            </div>
          ) : (
            <div slot="action-zone" className="timeout-modal-btn-container">
              <MFBeaconButton
                variant="tertiary"
                noButtonMargin
                id="timeoutModalLogoutBtn"
                data-name="timeoutModalLogoutBtn"
                onClick={() => {
                  modalCloseHandler();
                  logout();
                }}
                label="Log out"
              />
              <MFBeaconButton
                id="timeoutModalSessionRefreshBtn"
                data-name="timeoutModalSessionRefreshBtn"
                noButtonMargin
                variant="primary"
                onClick={() => {
                  modalCloseHandler();
                  handleSessionReset();
                }}
                label="Keep me logged in"
              />
            </div>
          )}
          <style jsx>{styles}</style>
        </MFBeaconModal>
      )}
    </>
  );
};

TimeOutModal.propTypes = {
  warningTimeManualExpire: PropTypes.bool
};

export default TimeOutModal;
